import React from 'react';
import './RechazoConfirmacionContent.css';

interface ServicioParaAprobar {
  id: number;
  nombre: string;
}

interface ConfirmacionAprobacionServicioProps {
  servicios: ServicioParaAprobar[];
  onCancelar: () => void;
  onConfirmarAprobacion: () => void;
  procesando?: boolean;
}

const ConfirmacionAprobacionServicio: React.FC<ConfirmacionAprobacionServicioProps> = ({
  servicios,
  onCancelar,
  onConfirmarAprobacion,
  procesando = false
}) => {

  return (
    <>
      <div className="rechazo-content">
        <p className="rechazo-description">
          Estás por aprobar {servicios.length === 1 ? 'el siguiente servicio' : 'los siguientes servicios'}
        </p>
        
        <div className="servicio-info-box">
          {servicios.map((servicio, index) => (
            <div key={servicio.id} className="servicio-nombre">
              {servicios.length > 1 && <span className="servicio-numero">{index + 1}. </span>}
              {servicio.nombre}
            </div>
          ))}
        </div>
      </div>
      
      <div className="rechazo-footer">
        <div className="rechazo-buttons">
          {!procesando && (
            <button
              onClick={onCancelar}
              className="rechazo-button-cancel"
            >
              Cancelar
            </button>
          )}
          <button
            onClick={onConfirmarAprobacion}
            disabled={procesando}
            className={`rechazo-button-confirm ${procesando ? 'disabled' : 'enabled'} aprobacion`}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            {procesando && (
              <svg
                style={{
                  animation: 'spin 1s linear infinite',
                  width: '16px',
                  height: '16px'
                }}
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeDasharray="31.4 31.4"
                  strokeLinecap="round"
                  opacity="0.25"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeDasharray="15.7 47.1"
                  strokeLinecap="round"
                  transform="rotate(-90 12 12)"
                />
              </svg>
            )}
            {procesando ? 'Procesando...' : 'Confirmar aprobación'}
          </button>
        </div>
      </div>
    </>
  );
};

// Agregar estilos de animación inline
if (typeof document !== 'undefined') {
  const styleId = 'confirmacion-servicio-spinner-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
}

export default ConfirmacionAprobacionServicio;